// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RN-z","twoColumnImage":"SN-z"};